import ProfilePage from './ProfilePage';
import ProfileTabContent from './ProfileTabContent';

export {
  ProfilePage,
  ProfileTabContent
};



// WEBPACK FOOTER //
// ./src/components/dashboard/index.js